import querystring from 'querystring'
import customIdentifier from './custom-parameter-prefix'

const generateArrayToString = (params) => {
  return (key) => {
    const value = params[key]
    if (Array.isArray(value)) {
      params[key] = value.join(', ')
    }
  }
}

const getQueryParameter = () => {
  const params = {
    utm: {},
    custom: {},
  }
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
  const queryParams = querystring.parse(window.location.search.substr(1))
  utmParams.forEach((utmParam) => {
    if (queryParams[utmParam]) {
      params.utm[utmParam] = queryParams[utmParam]
    }
  })

  Object.keys(queryParams)
    .filter((queryParam) => {
      if (utmParams.indexOf(queryParam) > -1) {
        return false
      }

      return queryParam.indexOf(customIdentifier) === 0
    })
    .forEach((param) => {
      const name = param.substr(customIdentifier.length)
      params.custom[name] = queryParams[param]
    })

  const arrayToString = generateArrayToString(params)

  Object.keys(params.utm).forEach(arrayToString)

  Object.keys(params.custom).forEach(arrayToString)

  return params
}

export default getQueryParameter
